import { useCallback, useState } from "react";
import { MAX_COMENTARIO } from "../constants/reportarProblema.constants";
import type {
    OpcionesReportarProblema,
    ResultadoReportarProblema,
} from "../types/reportarProblema.types";
import { esComentarioValido, limpiarComentario } from "../utils/reportarProblema.utils";

export const useReportarProblema = ({
    onEnviar,
    maxCaracteres = MAX_COMENTARIO,
}: OpcionesReportarProblema): ResultadoReportarProblema => {
    const [ancla, setAncla] = useState<HTMLButtonElement | null>(null);
    const [comentario, setComentario] = useState("");
    const [enviando, setEnviando] = useState(false);

    const abierto = Boolean(ancla);
    const puedeEnviar = esComentarioValido(comentario) && !enviando;

    const abrir = useCallback((evento: React.MouseEvent<HTMLButtonElement>) => {
        setAncla(evento.currentTarget);
    }, []);

    const cerrar = useCallback(() => {
        if (enviando) return;
        setAncla(null);
        setComentario("");
    }, [enviando]);

    const cambiarComentario = useCallback(
        (texto: string) => setComentario(limpiarComentario(texto, maxCaracteres)),
        [maxCaracteres]
    );

    const enviar = useCallback(async () => {
        if (!puedeEnviar) return;
        setEnviando(true);
        try {
            const resultado = await onEnviar(comentario.trim());
            if (resultado !== false) {
                setAncla(null);
                setComentario("");
            }
        } finally {
            setEnviando(false);
        }
    }, [puedeEnviar, onEnviar, comentario]);

    return {
        ancla,
        abierto,
        comentario,
        enviando,
        puedeEnviar,
        abrir,
        cerrar,
        cambiarComentario,
        enviar,
    };
};